export const THEME_NAMES = ["light", "dark"] as const;
export const ACCENT_NAMES = ["teal", "blue", "violet", "green", "amber", "rose"] as const;
export type ThemeName = (typeof THEME_NAMES)[number];
export type AccentName = (typeof ACCENT_NAMES)[number];

/** Apply the theme + accent to <html> data attributes (system = follow device). */
export function applyTheme(theme: ThemeName, accent: AccentName): void {
  const el = document.documentElement;
  el.setAttribute("data-theme", theme);
  el.setAttribute("data-accent", accent);
}
